import { defineMessages } from '@transcend-io/internationalization';

export const privacySettingMessages = defineMessages(
  'privacy-center.pages.ManageYourPrivacy.components.PrivacySettings.privacySetting',
  {
    intro: {
      defaultMessage: 'Privacy Settings',
      description:
        'The description text displayed for "Privacy Settings" page.',
    },
    loggedOutMessage: {
      defaultMessage:
        'Manage your various privacy settings below ' +
        'to take control of how your personal data gets accessed and used. ' +
        'Some customizations will require you to provide an identifier ' +
        '(i.e., email) or to log in to be authenticated in order to proceed.',
      description:
        'The description text displayed displayed conditionally for unauthenticated users on the ' +
        '"Privacy Settings" page.',
    },
    loggedInMessage: {
      defaultMessage:
        'Manage your various privacy settings below ' +
        'to take control of how your personal data gets accessed and used.',
      description:
        'The description text displayed displayed conditionally for authenticated users on the ' +
        '"Privacy Settings" page.',
    },
    unauthenticatedUpdatesWarning: {
      defaultMessage:
        'Note that your changes will take effect only on the client side. ' +
        'To fully effectuate your changes on our backend systems, {logIn}.',
      description:
        'The message displayed for unauthenticated users on purpose tiles in' +
        '"Privacy Settings" page.',
    },
    logIn: {
      defaultMessage: 'log in',
      description:
        'The text displayed on the link that allows the user to log-in from the ' +
        '"Privacy Settings" page.',
    },
    emailOptOutDescription: {
      defaultMessage:
        'Enter your email address to fully effectuate your opt-out request in our backend systems.',
      description:
        'Email address input label text when choosing to opt out of sale on "Privacy Settings" page.',
    },
    emailPlaceholder: {
      defaultMessage: 'Enter your email address',
      description:
        'Placeholder text for the email address input on "Privacy Settings" page.',
    },
    success: {
      defaultMessage: 'Successfully updated your preferences',
      description: 'The text displayed when privacy settings are updated',
    },
    unconfirmedChanges: {
      defaultMessage:
        'You have unsaved changes. Are you sure you want to leave?',
      description:
        'The confirmation message when user tries to leave the "Privacy Settings" page with unsaved changes.',
    },
    resetPreferences: {
      defaultMessage: 'Reset changes',
      description:
        'The button text to reset purposes in "Privacy Settings" page.',
    },
    updatePreferences: {
      defaultMessage: 'Save Changes',
      description:
        'The button text to update settings in "Privacy Settings" page.',
    },
    optOutAll: {
      defaultMessage: 'Opt out of all purposes',
      description:
        'The button text to opt-out from all purposes in "Privacy Settings" page.',
    },
    optInAll: {
      defaultMessage: 'Opt in to all purposes',
      description:
        'The button text to opt-in to all purposes in "Privacy Settings" page.',
    },
    optOut: {
      defaultMessage: 'Opt out',
      description:
        'Text for the button to opt out of the sale on "Privacy Settings" page.',
    },
    optOutSuccess: {
      defaultMessage: 'Opted out successfully!',
      description: 'Sale opt out success message on "Privacy Settings" page.',
    },
    noRegimePurposes: {
      defaultMessage: 'No settings are currently available.',
      description:
        'The message displayed when no purposes are configured for a regime on the "Privacy Settings" page.',
    },
  },
);
